export default {
    data(){
        return {
            payment: 1000,
            payway: 'WechatApp', //支付方式
            isAgree: true, //是否同意使用条款,
            orderCode: null
        }
    },
    methods: {
        //选择支付方式
        chgPayway(payway){
            this.payway = payway;
        },
        //同意使用条款
        chgAgree(){
            this.isAgree = !this.isAgree;
        },
        //提交支付
        handle(){
            var _this = this;
            if(!_this.isAgree){
                console.log("请确定已经仔细阅读《押金使用说明》");
                return false;
            }

            if (_this.orderCode) {
              _this.doPay();
              return;
            }


            _this.$post("/customerservicemanager/createdepositorder",{
              "PayWayCode": _this.payway,
              "Amount": _this.payment,
              "Channel": 3,
              "OrderType": 4
            },function (ret) {
              if(ret.Success){
                _this.orderCode = ret.Result.OrderCode;
                _this.doPay();
              }else{
                _this.$toast(ret.Message);
              }
            });

        },
        doPay() {
          if (this.payway === 'WechatApp') {
            this.wechatPay();
          } else if (this.payway === 'AlipayApp') {
            this.alipay();
          }
        },

      wechatPay() {
        let _this = this;
        this.wechatPayResult = "微信支付中";

        _this.$postPay("/pay/up/deposit",{
          "PayWayCode": _this.payway,
          "OrderCode": _this.orderCode,
          "ClientCode": "UnionPlusAlly",
          "PaymentType": 16
        },function (ret) {
          if(ret.Success){
            var wechatOrder = {
              appid: ret.Result.AppId,
              partnerid: ret.Result.PartnerId,
              prepayid: ret.Result.PrepayId,
              packagevalue: ret.Result.Package,
              noncestr: ret.Result.NonceStr,
              timestamp: ret.Result.TimeStamp,
              sign: ret.Result.PaySign
            };

            dsBridge.call("wechatPay", wechatOrder, function (data) {
              if (data) {
                _this.$toast("支付成功");
                _this.$router.push({name:"myAccount"});
              } else {
                _this.$toast("支付失败");
              }
              //_this.wechatPayResult = data ? "支付成功" : "支付失败";
            });
          }else{
            _this.$toast(ret.Message);
          }
        });
      },
      alipay() {
        let _this = this;

        _this.alipayResult = "支付宝支付中";
        _this.$postPay("/pay/up/deposit",{
          "PayWayCode": _this.payway,
          "OrderCode": _this.orderCode,
          "ClientCode": "UnionPlusAlly",
          "PaymentType": 16
        },function (ret) {
          if(ret.Success){
            var signData = ret.Result;
            dsBridge.call("alipay", signData, function (data) {
              if (data) {
                _this.$toast("支付成功");
                _this.$router.push({name:"myAccount"});
              } else {
                _this.$toast("支付失败");
              }
            });
          }else{
            _this.$toast(ret.Message);
          }
        });
      }
    }
}



// WEBPACK FOOTER //
// ./src/ally/page/pay/deposit.js